import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_REPORTS_BASE = "/admin/reports";

export async function generateSummaryReport(payload) {

  try {
    const finalPayload = {
      ...payload,
      type: "Summary",
    };

    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.post(API_REPORTS_BASE, finalPayload, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const ReportSummarizeService = {
  generateSummaryReport,
};

export default ReportSummarizeService;
